import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

export const adminGuard: CanActivateFn = async (route, state) => {
  const keycloakService = inject(KeycloakService);
  const router = inject(Router);

  const isLoggedIn = await keycloakService.isLoggedIn();
  
  if (!isLoggedIn) {
    // Redirect to login
    await keycloakService.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  const hasAdminRole = keycloakService.isUserInRole('admin');
  
  if (!hasAdminRole) {
    // User is logged in but doesn't have admin role
    router.navigate(['/']);
    return false;
  }

  return true;
};
